// src/components/SidebarExpertReviews.jsx
import React from 'react';
import bentley from '../assets/bentley.png';
import gclass from '../assets/gclass.png';
import adas from '../assets/adas.png';
import q5 from '../assets/q5.png';
import geneva from '../assets/geneva.png';
import './SidebarExpertReviews.css';

const expertReviews = [
  {
    title: "Bentley Plug-in hybrid will debut in March 2018",
    image: bentley,
  },
  {
    title: "Mercedes Benz confirms G Class will Debut in Detroit",
    image: gclass,
  },
  {
    title: "Six hot car technology to watch this year 2018",
    image: adas,
  },
  {
    title: "2018 Audi Q5: Latest First Drive Review",
    image: q5,
  },
  {
    title: "88th Geneva Motor Show is seeing great response!",
    image: geneva,
  },
];

const SidebarExpertReviews = () => {
  return (
    <div className="expert-sidebar">
      <h3 className="expert-title">EXPERT REVIEWS</h3>
      <ul className="expert-list">
        {expertReviews.map((item, index) => (
          <li className="expert-item" key={index}>
            <img src={item.image} alt={item.title} className="expert-img" />
            <p className="expert-text">{item.title}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarExpertReviews;
